import { ObjectResolverClient } from './ObjectResolverClient';

const _default_1: ObjectResolverClient = new ObjectResolverClient();

export default _default_1;
